import { InvoiceStatus } from "@common/types/invoice";
import { StatusFilterType } from "@common/types/statusFilter";
import {
    InvoiceView,
    InvoiceLineItemView,
    InvoicesByCustomerView,
} from "@common/types/views/invoiceViews";
import { NamedView } from "@common/types/views/views";
import { formatISO } from "date-fns";
import { DATE_RANGE_PRESETS_BY_ID } from "@helpers/date";
import { createAccrualReviewInvoiceLineItemsView } from "./AccrualReviewInvoiceLineItemsView";
import {
    defaultInvoiceLineItemsView,
    defaultInvoicesByCustomerView,
    defaultInvoicesView,
} from "./defaultInvoiceViews";

const allInvoicesView: NamedView<InvoiceView> = {
    ...defaultInvoicesView,
    id: "default",
    name: "All invoices",
};

const allInvoiceLineItemsView: NamedView<InvoiceLineItemView> = {
    ...defaultInvoiceLineItemsView,
    id: "default",
    name: "All line items",
};

const AGING_INVOICES_REVIEW_FILTERS = {
    invoiceStatusFilter: {
        filterType: StatusFilterType.ALL_SELECTED,
        kickStatuses: [],
        externalStatuses: [
            InvoiceStatus.DRAFT,
            InvoiceStatus.OPEN,
            InvoiceStatus.PAID,
        ],
    },
};

const agingInvoicesReviewByCustomerView: NamedView<InvoicesByCustomerView> = {
    ...defaultInvoicesByCustomerView,
    id: "ledger-review",
    name: "Aging invoices review",
    filters: AGING_INVOICES_REVIEW_FILTERS,
};

const BUILT_IN_INVOICE_VIEWS: Array<NamedView<InvoiceView>> = [allInvoicesView];
const BUILT_IN_INVOICE_LINE_ITEM_VIEWS: Array<NamedView<InvoiceLineItemView>> =
    [allInvoiceLineItemsView];
const BUILT_IN_INVOICES_BY_CUSTOMER_VIEWS: Array<
    NamedView<InvoicesByCustomerView>
> = [agingInvoicesReviewByCustomerView];

export function useBuiltInInvoiceViews() {
    return BUILT_IN_INVOICE_VIEWS;
}

export function useBuiltInInvoiceLineItemViews() {
    const today = new Date();
    const last30Days = DATE_RANGE_PRESETS_BY_ID.last_30_days;
    return [
        ...BUILT_IN_INVOICE_LINE_ITEM_VIEWS,
        createAccrualReviewInvoiceLineItemsView({
            createdOnFrom: formatISO(last30Days.getStart(today), {
                representation: "date",
            }),
            createdOnTo: formatISO(last30Days.getEnd(today), {
                representation: "date",
            }),
        }),
    ];
}

export function useBuiltInInvoicesByCustomerViews() {
    return BUILT_IN_INVOICES_BY_CUSTOMER_VIEWS;
}
